import React from 'react';
import './Programs.css';

function Programs({ language }) {
  const texts = {
    en: {
      conference: {
        title: 'Boya Video Game Academic Conference',
        content: 'The Boya International Video Game Academic Conference is hosted by VGARC and is generally held at Peking University in Beijing every April. The conference adheres to an open, diverse, and serious organizational format, with the core mission of "initiating and gathering cutting-edge discussions in the field of game studies," establishing a fair, open, and sustainable conference ecosystem. Upholding the philosophy that games should be fun and game studies should also be interesting, the conference actively seeks organic integration between academic research and game practice, uniting global game studies academic forces to establish an international platform for game studies exchange. In recent years, the conference has received over 200 submissions annually from 90+ universities and organizations worldwide, covering young scholars, master\'s and doctoral students, undergraduates, game developers, artists, and other diverse participants. It has also invited leading figures in game studies and humanities and arts research to participate in discussions.'
      },
      workshop: {
        title: 'Game Studies Workshop',
        content: 'The workshop focuses on cutting-edge research topics in the field of video games, starting from specific research subjects and flexibly using various formats such as lectures, seminars, roundtable forums, practical courses, and oral history to conduct in-depth exploration of research subjects and transform the above work into results, accumulating first-hand game research materials and providing important infrastructure for research from various perspectives.'
      },
      courses: {
        title: 'Game Studies Courses',
        content: 'The center and junior fellows make full use of Peking University\'s educational and teaching resources to conduct video game research-related courses on campus, and cooperate with Tsinghua University to develop inter-university collaborative courses. For example, junior fellow Cao Qi has offered the undergraduate general education course "The History of Video Games Transforming the Human World," and the center has collaborated with Tsinghua University\'s Rixing Academy to offer the undergraduate seminar course "Video Games and Philosophy," both of which have received unanimous praise from teachers and students on and off campus, making foundational contributions to promoting the achievement and popularization of video game academic research in general education, and providing ideas and references for offering more video game-related courses in the future.'
      },
      translation: {
        title: 'Game Culture Classic Translation Series',
        content: 'This translation series carefully selects the most representative and influential classic works in the field of Western video game studies, aiming to fill the gaps in domestic video game research in terms of humanistic perspective and theoretical depth through translation and introduction of these important intellectual achievements, provide rich theoretical resources for the domestic academic community, inspire more creative academic discussions, promote video game studies to achieve comprehensive understanding of video games from multiple dimensions including history, philosophy, and art theory, and through the window of video games, enable the public to more deeply understand the human condition in the technological age and actively respond to the various challenges and opportunities brought by digital culture.'
      },
      upcomingBooks: 'Currently Translating:'
    },
    zh: {
      conference: {
        title: '博雅电子游戏学术年会',
        content: '博雅国际电子游戏学术年会由VGARC主办，一般于每年四月在北京大学举行。会议坚持开放多元且严肃的组织形式，以「发起并汇聚游戏研究领域最前沿主题讨论」为核心，建立公平、公开、可持续的会议生态。秉持游戏要好玩、游戏研究也要有趣的办会理念，积极寻求学术研究与游戏实践的有机结合，团结全球游戏研究学术力量，建立国际化的游戏研究交流平台。近两年会议，年均收到来自全球90+所高校、组织机构超过200份投稿，涵盖青年学者、硕博研究生、本科生、游戏制作人、艺术家等多种面向，也邀请了游戏研究与人文艺术领域研究的领军人物参与讨论。'
      },
      workshop: {
        title: '游戏研究工作坊',
        content: '工作坊围绕电子游戏领域前沿研究主题，从具体的研究对象出发，灵活使用讲座、研讨会、圆桌论坛、实践课程、口述史等多种形式，对研究对象展开深度探讨并将上述工作成果化，积累一手游戏研究材料，为从各个视角展开研究提供重要基础设施。'
      },
      courses: {
        title: '游戏研究课程',
        content: '中心及青年研究员充分利用北京大学的教育教学资源，在北大校内展开电子游戏研究相关课程，并与清华大学合作展开校际合作课程。例如，青年研究员曹琪老师开设了本科通识课《电子游戏改造人类世界的历史》，中心与清华大学日新书院开设本科研讨课《电子游戏与哲学》等，均收获了校内外师生的一致好评，为推动电子游戏学术研究的成果化与通识教育的普及做出了基础性工作，也为今后开设更多电子游戏相关课程提供了思路与参考。'
      },
      translation: {
        title: '游戏文化经典译丛',
        content: '该译丛精选西方电子游戏研究领域最具代表性和影响力的经典著作，旨在通过翻译和介绍这些重要的思想成果，填补国内电子游戏研究在人文学科视野和理论深度上的不足，为国内学界提供丰富的理论资源，引发更具创造性的学术讨论，推动电子游戏研究实现从历史、哲学、艺术理论等多重维度对电子游戏的全面理解，并通过电子游戏这一窗口，使大众更深刻地理解技术时代的人类处境，积极回应数字文化带来的种种挑战与机遇。'
      },
      upcomingBooks: '正在翻译：'
    }
  };

  const currentTexts = texts[language];

  return (
    <div className="programs-page" data-language={language}>
      <div className="page-container">
        <div className="page-content">
          <div className="program-section">
            <div className="floating-element top-left"></div>
            <div className="floating-element bottom-right"></div>
            <div className="boya-conference-container">
              <img 
                src={require('../assets/boya.png')} 
                alt="Boya Conference" 
                className="boya-full-width-image"
              />
              <div className="boya-title-container">
                <h3 className="boya-section-title">{currentTexts.conference.title}</h3>
              </div>
              <div className="boya-content-container">
                <div className="boya-left-section">
                  <div className="conference-year-card">
                    <img 
                      src={require('../assets/2024.jpg')} 
                      alt="2024年会" 
                      className="year-conference-image"
                    />
                    <div className="year-conference-info">
                      <div className="year-title">{language === 'en' ? '2024 Conference' : '2024年会'}</div>
                      <div className="year-theme">
                        {language === 'en' ? 'Theme: Sight/Site Emergence' : '主题：视/世界涌现'}
                      </div>
                    </div>
                  </div>
                  <div className="conference-year-card">
                    <img 
                      src={require('../assets/2025.jpg')} 
                      alt="2025年会" 
                      className="year-conference-image"
                    />
                    <div className="year-conference-info">
                      <div className="year-title">{language === 'en' ? '2025 Conference' : '2025年会'}</div>
                      <div className="year-theme">
                        {language === 'en' ? 'Theme: Prototype Suture/Gap' : '主题：原型缝合/隙'}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="boya-right-section">
                  <div className="section-content">
                    <p className="content-paragraph">{currentTexts.conference.content}</p>
                  </div>
                  
                  {/* Three horizontal subsections */}
                  <div className="conference-features">
                    <div className="feature-item">
                      <img 
                        src={require('../assets/gifts.jpg')} 
                        alt="Conference Gifts" 
                        className="feature-image"
                      />
                      <p className="feature-text">
                        {language === 'en' 
                          ? 'The Boya Game Conference designs and collaborates with material manufacturers every year to launch conference-exclusive merchandise, providing attendees with memorable and ceremonial conference materials, gradually becoming one of the conference\'s distinctive features.'
                          : '博雅游戏年会每年均自行设计并与物料制作厂商合作推出年会限定周边，为与会者提供具有纪念意义与仪式感的会议物料，逐渐成为年会的特色之一。'
                        }
                      </p>
                    </div>
                    
                    <div className="feature-item">
                      <img 
                        src={require('../assets/roundtable.png')} 
                        alt="Roundtable Forum" 
                        className="feature-image"
                      />
                      <p className="feature-text">
                        {language === 'en' 
                          ? 'The conference hosts open roundtable forums, inviting game practitioners and researchers to engage in intellectual exchange and collision in a more relaxed manner, and also organizes game trial activities to enrich the conference content.'
                          : '年会开放圆桌论坛，邀请游戏从业者、研究者等以较为轻松的方式进行思想交流与碰撞，也组织游戏试玩等活动丰富年会内容。'
                        }
                      </p>
                    </div>
                    
                    <div className="feature-item">
                      <img 
                        src={require('../assets/media.png')} 
                        alt="Media Coverage" 
                        className="feature-image"
                      />
                      <p className="feature-text">
                        {language === 'en' 
                          ? 'The conference has received widespread attention from multiple gaming and official media outlets, as well as PKU official WeChat, gaining multiple headline reports and becoming one of the most watched conferences in the field of game studies.'
                          : '年会得到了多个游戏及官方媒体，北大官微的广泛关注，获得多个头条报道，成为游戏研究领域最受关注的会议之一。'
                        }
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="program-section">
            <div className="floating-element top-left"></div>
            <div className="floating-element bottom-right"></div>
            <div className="section-container">
              <div>
                <h3 className="section-title">{currentTexts.workshop.title}</h3>
                <div className="section-content">
                  <p className="content-paragraph">{currentTexts.workshop.content}</p>
                  <div className="workshop-submodules">
                    <div className="workshop-card">
                      <img 
                        src={require('../assets/yantaoban.png')} 
                        alt={language === 'en' ? "Game Studies Seminar" : "游戏研究研讨班"} 
                        className="workshop-card-image"
                      />
                      <div className="workshop-card-title">
                        {language === 'en' ? 'Game Studies Seminar' : '游戏研究研讨班'}
                      </div>
                      <div className="workshop-card-desc">
                        {language === 'en' 
                          ? 'Weekly discussions based on specific research questions. The theme of the 2025 Boya Game Conference is one of the outcomes of this seminar. Currently focusing on organizing key concepts and terminology in video game studies, this is one of the regular activities of the research center.'
                          : '每周基于明确的研究问题展开讨论，2025博雅游戏年会的主题便是研讨班的成果之一，目前正在针对电子游戏研究的关键概念与术语进行梳理，是创研中心的日常活动之一。'
                        }
                      </div>
                    </div>

                    <div className="workshop-card">
                      <img 
                        src={require('../assets/gongzuofang.png')} 
                        alt={language === 'en' ? "Interdisciplinary Workshop" : "跨界工作坊"} 
                        className="workshop-card-image"
                      />
                      <div className="workshop-card-title">
                        {language === 'en' ? 'Interdisciplinary Workshop' : '跨界工作坊'}
                      </div>
                      <div className="workshop-card-desc">
                        {language === 'en' 
                          ? 'Focuses on the history, development, genres of games, and their intersections with philosophy, ethics, and education. Based on translations of classic overseas game studies literature, the workshop aims to deepen understanding of video games as cultural phenomena through multi-perspective analysis and discussion, exploring their position and influence in contemporary society. Related translations from the workshop have been successively published in authoritative academic journals.'
                          : '聚焦游戏的历史、发展、类型以及与哲学、伦理和教育的交汇点。工作坊基于海外经典游戏研究文献翻译，旨在通过多角度的分析和讨论，深化对电子游戏作为文化现象的理解，探索其在当代社会中的地位和影响。工作坊相关译介已陆续由权威学术期刊刊出。'
                        }
                      </div>
                    </div>

                    <div className="workshop-card">
                      <img 
                        src={require('../assets/renwenluntan.png')} 
                        alt={language === 'en' ? "PKU Humanities Forum" : "北大人文论坛"} 
                        className="workshop-card-image"
                      />
                      <div className="workshop-card-title">
                        {language === 'en' ? 'PKU Humanities Forum' : '北大人文论坛'}
                      </div>
                      <div className="workshop-card-desc">
                        {language === 'en' 
                          ? 'Held in October 2024, focusing on the adaptation and recreation of the Four Great Classical Novels in video games, exploring how classic literature can be revitalized in the digital age. Industry pioneers such as Bian Xiaochun and experts in the Four Great Classical Novels were invited to participate in discussions, aiming to promote dialogue between traditional culture and video games, demonstrating the potential of games in cultural inheritance and innovation.'
                          : '24年10月举办，聚焦电子游戏中四大名著的改编与再创作探讨经典文学如何在数字化时代焕发新生。邀请了电子游戏产业先行者如边晓春，以及四大名著研究专家参与讨论，旨在推动传统文化与电子游戏对话，展示游戏在文化传承与创新中的潜力。'
                        }
                      </div>
                    </div>

                    <div className="workshop-card">
                      <img 
                        src={require('../assets/xueshujiuba.png')} 
                        alt={language === 'en' ? "Academic Bar" : "学术酒吧"} 
                        className="workshop-card-image"
                      />
                      <div className="workshop-card-title">
                        {language === 'en' ? 'Academic Bar' : '学术酒吧'}
                      </div>
                      <div className="workshop-card-desc">
                        {language === 'en' 
                          ? 'Junior fellows from the research center utilize innovative forms of academic communication to popularize video game studies to the general public, presenting video game research outcomes with a more pragmatic approach and providing new ideas for the activation of academic achievements.'
                          : '创研中心青年研究员利用新型的学术传播形式，面向大众普及电子游戏研究，以更为务实的态度呈现电子游戏研究成果，并为学术成果的活化提供了新思路。'
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="program-section courses-section">
            <div className="floating-element top-left"></div>
            <div className="floating-element bottom-right"></div>
            <div className="section-container">
              <div>
                <h3 className="section-title">{currentTexts.courses.title}</h3>
                <div className="section-content">
                  <p className="content-paragraph">{currentTexts.courses.content}</p>
                  
                  {/* New course sections */}
                  <div className="course-items">
                    <div className="course-item">
                      <img 
                        src={require('../assets/gaizaorenlei.png')} 
                        alt={language === 'en' ? 'The History of Video Games Transforming the Human World' : '电子游戏改造人类世界的历史'} 
                        className="course-image"
                      />
                      <div className="course-text">
                        {language === 'en' ? 'The History of Video Games Transforming the Human World' : '电子游戏改造人类世界的历史'}
                      </div>
                    </div>
                    
                    <div className="course-item">
                      <img 
                        src={require('../assets/qinghua.png')} 
                        alt={language === 'en' ? 'Video Games and Philosophy Seminar' : '电子游戏与哲学专题研讨课'} 
                        className="course-image"
                      />
                      <div className="course-text">
                        {language === 'en' ? 'Video Games and Philosophy Seminar' : '电子游戏与哲学专题研讨课'}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="program-section">
            <div className="floating-element top-left"></div>
            <div className="floating-element bottom-right"></div>
            <div className="section-container">
              <div>
                <h3 className="section-title">{currentTexts.translation.title}</h3>
                <div className="section-content">
                  <p className="content-paragraph">{currentTexts.translation.content}</p>
                  <img 
                    src={require('../assets/books.png')} 
                    alt="Books" 
                    className="books-image"
                  />
                </div>
              </div>
            </div>
          </div>
          
          <div className="upcoming-books-section">
            <div className="upcoming-books-container">
              <div className="upcoming-text">{currentTexts.upcomingBooks}</div>
              <img 
                src={require('../assets/upcomingbooks.png')} 
                alt="Upcoming Books" 
                className="upcoming-books-image"
              />
            </div>
          </div>
        </div>
        
        <footer className="game-footer">
          <div className="footer-text">
            © 2025 Video Game and Art Research Center, Peking University
          </div>
        </footer>
      </div>
    </div>
  );
}

export default Programs;
